<ng-container *ngIf="numberOfImageDisplayed > 0">
    <div class="image-variants">
        <ng-container *ngFor="let asset of displayedAssets(); let i = index">
            <ng-container *ngIf="asset.codeRgb; else templateImage">
                <div [style.background-color]="asset.codeRgb" class="image-variants-with-code-rgb"></div>
            </ng-container>
            <ng-template #templateImage>
                <ng-container *ngIf="asset.url && !asset.isBrokenImage">
                    <img
                        aria-hidden="true"
                        [ngSrc]="generateUrlAsset(asset.url)"
                        [attr.alt]="asset.title"
                        class="image-exist"
                        width="10"
                        height="10"
                        (error)="handleErrorImage(asset, i)" />
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container [ngTemplateOutlet]="accessibilityRef"></ng-container>
        <ng-container *ngIf="assetsRemainingNotDisplayed() > 0">
            <span class="more-variants">+ {{ assetsRemainingNotDisplayed() }}</span>
        </ng-container>
    </div>
</ng-container>
